<p-dialog
    appDialogoPadrao="pi pi-shield"
    descricao="Permissão individual do catálogo."
    [header]="modoEdicao() ? 'Editar descrição' : 'Nova role'"
    [visible]="showDialog()"
    (visibleChange)="showDialog.set($event)"
    [style]="{ width: '34rem', maxWidth: '95vw' }"
    (onHide)="fechar()"
>
    <div class="flex flex-col gap-3">
        @if (modoEdicao()) {
            <label class="flex flex-col gap-1 text-sm font-medium"
                >Role
                <input pInputText [value]="edicao()!.name" [readonly]="true" class="font-mono opacity-70" />
            </label>
        } @else {
            <label class="flex flex-col gap-1 text-sm font-medium"
                >Módulo
                <p-autocomplete
                    [ngModel]="modulo()"
                    (ngModelChange)="setModulo($event)"
                    (keydown)="bloquearPonto($event)"
                    [suggestions]="sugestoes()"
                    (completeMethod)="filtrar(modulosSugeridos(), $event)"
                    [dropdown]="true"
                    appendTo="body"
                    [scrollHeight]="'14rem'"
                    placeholder="ex.: arrecadacao"
                />
            </label>
            <label class="flex flex-col gap-1 text-sm font-medium"
                >Funcionalidade
                <p-autocomplete
                    [ngModel]="funcionalidade()"
                    (ngModelChange)="setFuncionalidade($event)"
                    (keydown)="bloquearPonto($event)"
                    [suggestions]="sugestoes()"
                    (completeMethod)="filtrar(funcionalidadesSugeridas(), $event)"
                    [dropdown]="true"
                    appendTo="body"
                    [scrollHeight]="'14rem'"
                    placeholder="ex.: creditos"
                />
            </label>
            <label class="flex flex-col gap-1 text-sm font-medium"
                >Ação
                <input pInputText [ngModel]="acao()" (ngModelChange)="setAcao($event)" (keydown)="bloquearPonto($event)" placeholder="ex.: utilizar" />
            </label>
        }
        <label class="flex flex-col gap-1 text-sm font-medium"
            >Descrição
            <input pInputText [ngModel]="descricao()" (ngModelChange)="descricao.set($event)" placeholder="Descrição amigável" />
        </label>
        @if (!modoEdicao()) {
            <div class="text-sm">
                Role: <code>{{ preview() || '—' }}</code>
                @if (preview() && !valido()) {
                    <span class="text-red-500 ml-2">fora da convenção</span>
                }
            </div>
        }
    </div>
    <ng-template pTemplate="footer">
        <p-button label="Cancelar" severity="secondary" (onClick)="fechar()"></p-button>
        <p-button label="Salvar" icon="pi pi-check" [disabled]="!valido() || salvando()" [loading]="salvando()" (onClick)="salvar()"></p-button>
    </ng-template>
</p-dialog>
